import React, { useEffect, useState } from 'react';
import principalPic from "../assets/DSC03313.jpg.jpeg"; // Update with actual principal image path
import '../styles/PrincipalDesk.css';

export default function PrincipalMessage() {
    const [isVisible, setIsVisible] = useState(false);
        
          useEffect(() => {
            setIsVisible(true);
          }, []);

  return (
    <div className="principal-message-wrapper">
      
     {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Principal's Desk</h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="principal-message-content">

        {/* Left Side - Message */}
        <div className="principal-message-text-section">
        <h3 className="dear-students">Dear Students, Parents, and Staff</h3>
          <p className="principal-message-paragraph">
           I hope this message finds you in good health and high spirits. As we embark on another academic year, I am filled with a sense of
            optimism and excitement for the incredible journey ahead. Our school is not just a building; it is a community of learners, dreamers,
             and achievers. This year promises new opportunities for growth, knowledge, and personal development. Together, let us create an environment 
             that fosters curiosity, creativity, and compassion. Let us encourage each other to reach new heights and overcome challenges, for it is through
              collaboration and support that we truly thrive. Parents, your partnership is invaluable, and I encourage open communication throughout the year. 
              Staff, your dedication and passion inspire our students daily, and I am grateful for your commitment to their education. Students, you are the heartbeat
               of our school. Your unique talents, perspectives, and dreams contribute to the vibrant tapestry of our community. Embrace the learning journey, cherish
                the friendships you'll make, and remember that each day is an opportunity to make a positive impact. Wishing everyone a successful and fulfilling
                 academic year. Let us work hand in hand to make this a year of growth, achievement, and lasting memories.
          </p>
          <p className="principal-message-wishes">
            " Best Wishes For A Bright Future "
          </p>
        </div>
        
        {/* Right Side - Photo and Details */}
        <div className="principal-profile-section">
          <div className="principal-photo-container">
            <img src={principalPic} alt="Principal" className="principal-profile-image" />
          </div>
          
          <div className="principal-profile-details">
            <h2 className="principal-profile-name">Mr. ASHOK GROVER</h2>
            <p className="principal-profile-designation">PRINCIPAL</p>
            <p className="principal-profile-organization">SETH. G.L BIHANI S.D. SR. SEC. SCHOOL</p>
          </div>
        </div>

      </div>
    </div>
  );
}